import React from 'react';
import { Field, useFormikContext } from 'formik';
import Input from 'components/ui/formik/Input';

const FieldLegalAddress = () => {
  const { errors, touched } = useFormikContext();
  return (
    <Field
      id="legal_address"
      data-testid="legal_address"
      name="legal_address"
      labelText="Legal Company Address"
      touched={touched}
      errors={errors}
      as={Input}
    />
  );
};

export default FieldLegalAddress;
